module.exports = __webpack_public_path__ + "static/media/CalendarEvent1.652fedaa.jpg";